export const SET_TOKEN = 'Set token';
export const SET_SESSION = 'Set session';
export const SET_FEATURE_FLAGS = 'Feature flags initialized';
export const SET_USER_PROPERTY = 'Set user property';
export const SET_ACTIVE_ORGANIZATION = 'Set active organization';
export const INCREASE_PROFILE_ASSETS_COUNT = 'Increase profile assets count';
export const DECREASE_PROFILE_ASSETS_COUNT = 'Decrease profile assets count';
